import $ from 'jquery';

import calculateStrength from '../lib/password-strength';

function create(pwSel, meterSel) {
  const $pw = $('#password');
  const $meter = $('#password-strength-meter');

  $pw.on('input', () => {
    const pwText = $pw.val();
    const score = calculateStrength(pwText);
    $meter.val(score);
  });

  return $pw;
}

export default {
  create
};



// WEBPACK FOOTER //
// ./modules/password-strength-meter.js